const thousandsFrom = 100000;
const millionsFrom = 10000000;

export function formatStack(quantity: number): string {
  if (quantity >= millionsFrom) {
    return `${Math.floor(quantity / 1000000)}M`;
  }
  if (quantity >= thousandsFrom) {
    return `${Math.floor(quantity / 1000)}K`;
  }
  return String(quantity);
}
